module.exports = __webpack_public_path__ + "img/bx-14.72838770.jpg";